import { useEffect, useState } from 'react';
import { acompanharSistema, salvar, temaSalvo, type Tema as TipoTema } from '../lib/tema.ts';
import './tema.css';

const OPCOES: { valor: TipoTema; rotulo: string; titulo: string }[] = [
  { valor: 'claro', rotulo: '☀', titulo: 'Tema claro' },
  { valor: 'escuro', rotulo: '☾', titulo: 'Tema escuro' },
  { valor: 'auto', rotulo: 'A', titulo: 'Seguir o sistema' },
];

/** Três posições e não um interruptor de duas: sem o "seguir o sistema",
 *  quem deixa o computador trocar sozinho ao anoitecer fica preso no que
 *  escolheu uma vez. */
export function Tema() {
  const [tema, setTema] = useState<TipoTema>(temaSalvo);

  useEffect(() => acompanharSistema(() => setTema(temaSalvo())), []);

  return (
    <div className="tema" role="group" aria-label="Tema da tela">
      {OPCOES.map((o) => (
        <button
          key={o.valor}
          type="button"
          className="tema__opcao"
          data-ativa={tema === o.valor || undefined}
          title={o.titulo}
          aria-label={o.titulo}
          aria-pressed={tema === o.valor}
          onClick={() => {
            salvar(o.valor);
            setTema(o.valor);
          }}
        >
          <span aria-hidden="true">{o.rotulo}</span>
        </button>
      ))}
    </div>
  );
}
